import React, { useEffect, useState } from 'react'
import { CardHeader, EncuestaLoading, InfoCard, NameLabel, ThanksMessage, checkEncuesta, onFinishFailed, getNextSurveyUrl } from '../utils'
import { Form, Input, Button, message, Radio } from 'antd'
import { sendDataBody } from '../../resources'
import { phq9_catalog } from './phq9p.catalog'
export default function Phq9pEncuesta({ idpaciente, idmedico, token, visita, session, protocolo = 'default', chain = '' }) {

    const [encuestaNotExists, setEncuestaNotExists] = useState(null)
    const [checking, setChecking] = useState(true)
    const [pacienteData, setPacienteData] = useState({})
    const [medicoData, setMedicoData] = useState({})

    useEffect(() => {
        init()
    }, [])

    function init() {
        checkEncuesta(idpaciente, visita, 'phq9p', session, protocolo, setPacienteData, idmedico, setMedicoData, setEncuestaNotExists, setChecking)
    }

    const nextSurveyUrl = getNextSurveyUrl('phq9p', chain, idmedico, idpaciente, token, visita, session, protocolo);

    const onFinish = (values) => {
        console.log('Orginal values: ', values)
        //    example of values: {
        //     "0": 1,
        //     "1": 1,
        //     "2": 1,
        //     "3": 1,
        //     "4": 1,
        //     "5": 1,
        //     "6": 1,
        //     "7": 1,
        //     "8": 1,
        //     "9": 3
        // }
        const respuestas = Object.values(values)
        const lastValue = respuestas.pop()
        const body = {
            usuario: idpaciente,
            medico: idmedico,
            phq9p: respuestas,
            tipo: 'phq9p',
            uuid: token,
            visita,
            sesion: session,
            protocolo
        }
        console.log('Body:', body);
        sendDataBody('encuestas/add', body).then((rs) => {
            console.log('add enc resp', rs)
            message.success(rs.message)
        }).then(() => init())
    };

    const onChange = (e) => {
        console.log('radio checked', e.target.value);
    };

    if (checking) return <EncuestaLoading />

    if (!encuestaNotExists) return <ThanksMessage nextUrl={nextSurveyUrl} />

    return (
        <div className='parentContainer'>
            <CardHeader title="Encuesta PHQ9P">
                <NameLabel pacienteData={pacienteData} />

                <NameLabel pacienteData={medicoData} label="Médico: " />

                <InfoCard label="Sesión" value={session} />
            </CardHeader>
            <div className='formContainer'>
                <h5>Cuestionario sobre la salud del paciente-9</h5>
                <h6>(US Spanish version of the PHQ)</h6>
                <br />

                <p className='name'>Durante las ultimas dos semanas, ¿qué tan seguido ha tenido molestias por alguna de las siguientes dificultades?</p>

                <Form
                layout='vertical'
                name="phq9p_enc"
                // labelCol={{ span: 24 }}
                // wrapperCol={{ span: 24 }}
                initialValues={[]}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >

                {
                    phq9_catalog.map((q, i) => <Form.Item
                        label={q}
                        name={i}
                        rules={[
                            {
                                required: true,
                                message: 'Please input your username!',
                            },
                        ]}
                    >
                        <Radio.Group onChange={onChange} >
                            <Radio value={0}>"No del todo"</Radio>
                            <Radio value={1}>"Varios días"</Radio>
                            <Radio value={2}>"Más de la mitad de los días"</Radio>
                            <Radio value={3}>"Casi todos los días"</Radio>
                        </Radio.Group>
                    </Form.Item>)
                }

                <Form.Item
                    label="Si usted marcó cualquiera de los problemas, ¿qué tan difícil han afectado estos problemas en hacer su trabajo, encargarse de tareas del hogar, o llevarse bien con otras personas?"
                    name={9}
                    rules={[
                        {
                            required: true,
                            message: 'Please input your username!',
                        },
                    ]}
                >
                    <Radio.Group onChange={onChange} >
                        <Radio value={0}>Para nada dificil</Radio>
                        <Radio value={1}>Un poco difícil</Radio>
                        <Radio value={2}>Muy difícil</Radio>
                        <Radio value={3}>Extremaadamente difícil</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        offset: 8,
                        span: 16,
                    }}
                >
                    <Button form='phq9p_enc' type="primary" htmlType="submit">
                        Enviar respuestas
                    </Button>
                </Form.Item>

                {/* <Button type='primary' onClick={navToUrl} style={{ alignSelf: 'center' }}>Siguiente</Button> */}
            </Form>
            </div>
        </div>
    )
}